// copypasted from here:
// https://serverless-stack.com/chapters/code-splitting-in-create-react-app.html
// @andresokol

import React, { Component } from "react";

export default function asyncComponentLoader(importComponent) {
  class AsyncComponent extends Component {
    static Component = null;
    state = { Component: AsyncComponent.Component };

    componentWillMount() {
      if (!this.state.Component) {
        importComponent().then(({ default: C }) => {
          AsyncComponent.Component = C;
          this.setState({
            Component: C,
          });
        });
      }
    }

    render() {
      const C = this.state.Component;
      return C ? <C {...this.props} /> : null;
    }
  }

  return AsyncComponent;
}



// WEBPACK FOOTER //
// ./src/asyncComponentLoader.js